<template>
  <span>
    <template v-for="(item, i) of value">
      <span :key="item.key">
        <Form
          :fields="fields"
          :offset="3 * i"
          :data="item"
          :showErrors="showErrors"
          :disabled="disabled"
          @input="value => onChange(value, i)"
          @valid="valid => onValidChange(valid, i)"
        />

        <v-btn
          class="remove-sample-btn"
          v-if="i > 0"
          :disabled="disabled"
          @click="() => removeSample(i)"
          text
          ><v-icon left>fa-minus-circle</v-icon>Remove Product</v-btn
        >

        <Divider />
      </span>
    </template>

    <v-btn
      class="add-sample-btn"
      v-if="value && value.length < 10"
      @click="addSample"
      :disabled="disabled"
      text
    >
      <v-icon left>fa-plus-circle</v-icon>
      Add Product</v-btn
    >
  </span>
</template>

<script>
import _ from "lodash";
import httpService from "@/services/httpService";
import Form from "@/components/Form.vue";
import Divider from "@/components/Divider.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "SampleDetails",

  components: { Form, Divider },

  props: ["value", "showErrors", "disabled"],

  created()
  {
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    this.requested = params.get("requested");
    console.log(this.requested);
  },

  data: () => ({
    valid: {
      valid: false,
      forms: []
    },
    requested: {},
    requestedIdx: {},
    otherSku : ""
  }),

  async mounted() {
    if (!this.value || this.value.length === 0) {
      this.addSample();
    }
  },

  methods: {
    ...mapActions("app", ["fetchProducts"]),

    addSample() {
      const defaults = { key: Math.random() * 1000 };
      for (const field of this.fields) {
        if (field.default) {
          defaults[field.id] = field.default;
        }
      }

      this.$emit("input", [...(this.value || []), defaults]);
    },

    removeSample(index) {
      this.valid.forms.splice(index, 1);
      this.validate();

      const value = [...this.value];
      value.splice(index, 1);

      this.$emit("input", value);
    },

    onChange(value, index) {
      const data = this.value.map((item, i) => {
        if (i === index) {
          return value;
        }

        return item;
      });

      this.$emit("input", data);
    },

    onValidChange(valid, index) {
      this.valid.forms[index] = valid;
      this.validate();
    },

    validate() {
      let isValid = true;

      for (const valid of this.valid.forms) {
        if (!valid) {
          isValid = false;
          break;
        }
      }

      this.valid.valid = isValid;

      this.$emit("valid", isValid);
    },

    sampleKey(item) {
      // dirty workaround for indexes... without it
      // vue hydrates older items resulting in some
      // inconsistent states
      return Math.random() * 1000;
    },

  },

  computed: {
    ...mapGetters("app", ["samples", "samplesLoading"]),

    fields() {
      var chosen = false;
      return [
        {
          id: "sku",
          title: "Product Samples (Please select 'Other' for not available samples)",
          type: "dropdown",
          placeholder: "Select Product",
          required: true,
          choices: selectedSample => {
            const usedProducts = new Set(this.value?.map(p => p.sku));
            
            return this.samples
              .concat({ 
                sku: "Other",
              })
              .filter(
                ({ sku }) => sku === selectedSample || !usedProducts.has(sku)
              )
              .map(({ sku, status}, idx) => {
                const isOutOfStock = status === "out-of-stock";
               
                if (isOutOfStock) {
                  sku = `${sku} (Out of Stock)`;
                }

                if (sku == "Other"){
                   if (this.requested != null && _.isPlainObject(this.requestedIdx)){
                      this.requestedIdx = idx;
                      this.otherSku = this.requested + ": ";
                   }
                   return {
                    name: "Other"
                  }
                }
                  
                  if (sku == this.requested) {
                      this.requestedIdx = idx;
                      chosen = true;
                  }
                return {
                  name: sku,
                  disabled: isOutOfStock,
                  selected: chosen
                };
              });
          },
          loading: this.samplesLoading,
          selected: this.requestedIdx
        },
        {
          id: "quantity",
          title: "Quantity",
          type: "select",
          required: true,
          choices: _.range(1, 11),
          default: 1
        },
        {
          id: "other_sku",
          title: "Describe the sample that you need",
          type: "textarea",
          required: true,
          value: this.otherSku,
          show: data => {
            return data.sku === "Other";
          }
        },
        {
          id: "notes",
          title: "Notes",
          type: "textarea"
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.remove-sample-btn:hover {
  color: red !important;
}

.add-sample-btn:hover {
  color: #01943b !important;
}

.v-list-item--disabled {
  text-decoration: line-through;
}
</style>
